import { useContext } from 'react';

import { XYChartDownloadContext } from '../context/XYChartDownload.context.js';

export const useDownload = () => useContext(XYChartDownloadContext);
